import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Color } from '../../../models/new/style';
import { Shot } from '../../../models/new/shot';
import { MediaShareColorShots, MediaShareDetail } from '../../../models/new/media-share-detail';

@Component({
  standalone: false,
  selector: 'bt-company-media-share-link-detail-product',
  templateUrl: './company-media-share-link-detail-product.component.html',
  styleUrls: ['./company-media-share-link-detail-product.component.scss']
})
export class CompanyMediaShareLinkDetailProductComponent {
  @Input({ required: true }) product!: MediaShareDetail;
  @Output() toggleProduct = new EventEmitter<MediaShareDetail>();
  @Output() removeProduct = new EventEmitter<MediaShareDetail>();
  @Output() removeColor = new EventEmitter<Color>();
  @Output() openGallery = new EventEmitter<{ shots: Shot[]; first?: number }>();

  get productPath(): string {
    const style = this.product.style;
    return [
      style.brand?.name || 'Other brands',
      style.collection?.name || 'No collection',
      style.styleGroup?.name || 'No style group'
    ].join(' / ');
  }

  getShotsWithImages(colorShots: MediaShareColorShots): Shot[] {
    return colorShots.shots?.filter((shot) => shot.imgPath) || [];
  }

  isVideo(shot: Shot): boolean {
    const path = shot.imgPath?.toLowerCase() ?? '';
    return path.endsWith('.mp4') || path.endsWith('.mkv');
  }

  onOpenGallery(colorShots: MediaShareColorShots, first?: number): void {
    const shots = this.getShotsWithImages(colorShots);
    if (shots.length) {
      this.openGallery.emit({ shots, first });
    }
  }
}
